<template>
  <div class="card-quiz">
    <div class="meta">
      <h3>{{ slide.content.title }}</h3>
    </div>

    <div>
      <h1>{{ slide.content.question }}</h1>
      <div class="questions">
        <div v-for="(question, idx) in getQuestions" :key="idx" class="question" :class="{'answer' : question === answer, 'non-answer' : question !== answer && answer}" @click="selectAnswer(question)">
          {{ question }}
        </div>
      </div>

      <transition name="slide-fade" mode="out-in">
        <div v-if="isAnswering" class="question-result">
          <div v-if="hasAnswered">
            <h2 v-if="isCorrect">Awesome! You nailed it!</h2>
            <h2 v-if="!isCorrect">Oops, almost but not quite right. </h2>

            <p v-if="isCorrect">Great job! You got it right.</p>
            <p v-if="!isCorrect">Nice try! That answer's close, but not quite there. Try again?</p>
          </div>

          <div v-else>
            <span class="loading"></span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      meta: {
        type: Object,
      },
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        answer: null,
        isAnswering: false,
        hasAnswered: false,
        isCorrect: false,
      }
    },

    computed: {
      getQuestions() {
        let questions = [...this.slide.content.wrong, this.slide.content.correct];

        for (let i = questions.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [questions[i], questions[j]] = [questions[j], questions[i]];
        }

        return questions
      }
    },

    methods: {
      selectAnswer(question) {
        this.isAnswering = true;
        this.hasAnswered = false;
        this.isCorrect = false;
        this.answer = question;

        setTimeout(() => {
          if (this.slide.content.correct === question) {
            this.hasAnswered = true;
            this.isCorrect = true;
          } else {
            this.hasAnswered = true;
          }
        }, 2000);
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }

  .slide-fade-enter {
    opacity: 0;
    transform: translateY(10px);
  }

  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .loading {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    animation: rotate 1s linear infinite;

    &:before {
      content: "";
      box-sizing: border-box;
      position: absolute;
      inset: 0px;
      border-radius: 50%;
      animation: prixClipFix 2s linear infinite;
      border: 5px solid $neutral-100;

      .darkmode & {
        border: 5px solid $neutral-600;
      }
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes prixClipFix {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }
</style>